import React from 'react';
import { Center, Divider } from '~/commonComponents';
import VerifiedProsIcon from '../../../images/howItWorks/100Pros.svg';
import FastMatchingIcon from '../../../images/howItWorks/FastMatching.svg';
import PatientCareIcon from '../../../images/howItWorks/PatientCare.svg';
import { FeatureCard } from './FeatureCard';

export const FeaturesSection: React.FC = () => {
  return (
    <Center
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      maxWidth={1000}
      marginTop={20}
    >
      <FeatureCard
        icon={VerifiedProsIcon}
        title="100% Verified Professionals"
        description="Every professional is licensed, and verified before joining our platform."
      />
      <Divider width="2px" height={160} />
      <FeatureCard
        icon={FastMatchingIcon}
        title="Lightning Fast Matching"
        description="Get matched with qualified professionals within minutes."
        descriptionWidth={180}
      />
      <Divider width="2px" height={160} />
      <FeatureCard
        icon={PatientCareIcon}
        title="Focus on Patient Care"
        description="Spend more time with patients and less time on administrative tasks and scheduling."
      />
    </Center>
  );
};
